import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Multicat = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3">BronzeTag MultiCat for Quickbooks
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Multicat for Quickbooks</li>
                </ol>

                <div className="row">
                    <div className="col-lg-6">
                        <img className="img-fluid rounded mb-4" src="/images/altriaqb.png" alt=""></img>
                        <br/><br/>
                        <p>Here is a video tutorial on how to install and setup the software</p>
                        <iframe className="col-lg-8" height="315" src="https://www.youtube.com/embed/Wf0AfFXf3Sw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                    <div className="col-lg-6" style={{paddingLeft:20, paddingTop:50}}>
                        <p>Multicat for Quickbooks integrates with your Quickbooks desktop software and allows distributors to quickly begin reporting cigarette movement in the format necessary to satisfy the requirements of all the major cigarette manufacturers (MSA reporting).</p>
                        <p>New MultiCat Reporting Requirements for 2016 require that all BID brand records and PU purchase records must be updated to include:</p>

                        <div>Floor returns</div>
                        <div>Saleable returns</div>
                        <div>Unsaleable returns</div>
                        <br/>
                        <a href="./downloads/MulticatQBSetup-v1.0.zip" download>
                        Download Multicat for Quickbooks.
                        </a>
                        <br/><br/>
                        <a href="./downloads/MultiCat Format - TOB Format File Mapping.pdf" download>
                        Download MultiCat Format - TOB Format File Mapping.
                        </a>
                        <br/><br/>
                    </div>
                </div>
            
            </div>

            
    

    
    

    

  </div>
        
    )
}